const apiUrl = process.env.REACT_APP_API_URL;
export const PostOrdreTasca = async ( id_projecte : string, id_tasca : number , ordre : number) => {
    try {
        const response = await
            fetch(`${apiUrl}:8061/projectes/${id_projecte}/tasques/${id_tasca}/ordre?ordre=${ordre}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
